<template>
  <div style=" width: 1200px; margin: 0 auto; background-color: #F2F6FC;  ">
    <Title :title="route"></Title>
    <el-card class="container">
      <el-card class="export-content">
        <el-divider content-position="left">项目报销</el-divider>
        <span class="description">用于导出每个项目关联的各项报销费用</span>
        <el-row class="time">
          <el-date-picker
            v-model="reimburseParam.times"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-row>
        <el-button type="primary" @click="exportReimburse">导出</el-button>
      </el-card>
    </el-card>
  </div>
  
</template>

<script>
import Title from "../../Title";
import {requestExportReimburse} from "@/api"
export default {
  name: "Export",
  components: {Title},
  data() {
    return {
      route: {
        name: "导出管理",
        path: ""
      },
      reimburseParam: {
        times: []
      }
    }
  },
  created() {
    this.route.path = this.$route.fullPath
  },
  methods: {
    async exportReimburse() {
      const param = {
        startTime: this.reimburseParam.times[0],
        endTime: this.reimburseParam.times[1]
      }
      const res = await requestExportReimburse(param)
      if (res.code === 200) {
        window.location.href = res.object
        this.reimburseParam.times = []
        this.$message.success(res.msg)
      } else {
        this.$message.error(res.msg)
      }
    }
  }
}
</script>

<style>
.container {
  min-height: 650px;
  margin-top: 15px;
}
.export-content {
  width: 40%;
}
.time {
  margin: 10px 0;
}
.description {
  color: grey;
}
</style>